/**
 * Show Context Menu
 * @param {contextMenu} contextMenu - The contextMenu to be shown
 * @return {Function} A function to be called when the contextMenu should be shown
 */

export default (contextMenu) => {
  return function(mouseEvent) {
    contextMenu.hide()
    // Timeout is a fix for an issue in Firefox https://github.com/ipvideomarketinfo/calculator-v3/issues/547
    setTimeout(_ => contextMenu.show(mouseEvent.latLng), 1)
    google.maps.event.addDomListenerOnce(document, 'click', e => contextMenu.hide())
  }
}



// WEBPACK FOOTER //
// ./src/helpers/showContextMenu.js